<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import AlertError from "@/components/alert_error";
import { VueContentLoading } from "vue-content-loading";
import html2canvas from "html2canvas";
import VueQRCodeComponent from "vue-qrcode-component";
// import QrCodeCard from "@/components/qr_code_card";

export default {
  page: {
    title: "استمارة حجز بوث",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    AlertError,
    VueContentLoading,
    // QrCodeCard,
    VueQRCodeComponent,
  },
  data() {
    return {
      title: "تفاصيل الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/",
        },
        {
          text: "استمارة حجز بوث",
          href: "/booths",
        },
        {
          text: "التفاصيل",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      loadingContent: true,
      project: null,
      qrCodeContent: null,
      showAlert: false,
    };
  },
  computed: {
    ...mapGetters("boothsProject", ["getProject"]),
  },
  methods: {
    ...mapActions("boothsProject", ["get"]),
    handleError(error) {
      this.showAlert = true;
      const response = error.response;
      this.errors =
        response && response.status == 422 && response.data.errors
          ? Object.values(response.data.errors)
          : [
              response && response.data.message
                ? response.data.message
                : "تعذر الاتصال بالخادم، يرجى المحاولة مرة أخرى",
            ];
    },
    fetch() {
      this.get(this.id)
        .then(() => {
          this.project = this.getProject;
          this.loadingContent = false;

          this.qrCodeContent = JSON.stringify({
            Id: this.project.qr_id,
            fullName: this.project.full_name,
            date: this.project.created_at,
          });
        })
        .catch((error) => {
          this.handleError(error);
          this.loadingContent = false;
        });
    },

    // print card
    async download() {
      const el = this.$refs.printcontent;
      const options = { type: "dataURL" };
      const printCanvas = await html2canvas(el, options);
      const link = document.createElement("a");
      link.setAttribute("download", this.project.full_name + ".jpg");
      link.setAttribute(
        "href",
        printCanvas.toDataURL("image/jpg").replace("image/jpg", "image/octet-stream")
      );
      link.click();
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    // setTimeout(() => {
    //   this.loadingContent = false;
    // }, 1000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

        <div class="card">
          <div v-if="!loadingContent && project" class="card-body">
            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">بيانات المتقدم</h5></div>
            <div class="row about-list">
              <div class="col-md-6">
                <div class="media">
                  <label>الاسم الثلاثي :</label>
                  <p>{{ project.full_name }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>رقم الهاتف :</label>
                  <p>{{ project.phone }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>المحافظة :</label>
                  <p>
                    {{
                      project.address && project.address.city
                        ? project.address.city.title
                        : "-"
                    }}
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>المنطقة :</label>
                  <p>{{ project.address ? project.address.region : "-" }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات المشروع</h5></div>
            <div class="row about-list">
              <div class="col-md-6">
                <div class="media">
                  <label>اسم المشروع :</label>
                  <p>{{ project.project_name }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>قطاع المشروع :</label>
                  <p>{{ project.category }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>ملخص فكرة المشروع :</label>
                  <p>{{ project.abstract || project.abstuct }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>تاريخ تأسيس المشروع :</label>
                  <p>{{ project.date_ini }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>ملاحظات :</label>
                  <p>{{ project.note }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات البوث</h5></div>
            <div class="row about-list">
              <div class="col-md-6">
                <div class="media">
                  <label>قياس البوث :</label>
                  <p>{{ project.model }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>مكان البوث :</label>
                  <p>{{ project.location }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>حالة القبول :</label>
                  <p>{{ project.project_status ? project.project_status.title : "-" }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>تاريخ التقديم :</label>
                  <p>{{ project.created_at }}</p>
                </div>
              </div>
            </div>

            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">مواقع التواصل الاجتماعي</h5></div>
            <div class="row about-list">
              <div class="col-md-6">
                <div class="media">
                  <label>انستغرام :</label>
                  <p>{{ project.instagram }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>فيسبوك :</label>
                  <p>{{ project.facebook }}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="media">
                  <label>تيك توك :</label>
                  <p>{{ project.tiktok }}</p>
                </div>
              </div>
            </div>

            <!-- <QrCodeCard
              title="استمارة حجز بوث"
              :fullName="this.project.full_name"
              :date="this.project.created_at"
              :Id="this.project.qr_id"
              :qrCodeContent="this.qrCodeContent"
            ></QrCodeCard> -->

            <div class="text-center print-cover">
              <div class="card-print con-print text-center" ref="printcontent">
                <h5>معرض المشاريع النسائية الوطني 2026</h5>
                <p><strong>الاسم :</strong> {{ project.full_name }}</p>
                <p><strong>اسم المشروع :</strong> {{ project.project_name }}</p>
                <p><strong>تاريخ التقديم :</strong> {{ project.created_at }}</p>
                <p>
                  <strong>رقم البوث :</strong> {{ project.model + "" + project.location }}
                </p>
                <VueQRCodeComponent
                  class="qr-code"
                  :text="qrCodeContent"
                ></VueQRCodeComponent>
                <hr />
                <div class="">
                  <p class="mb-1">مؤسسة سيدة العالم</p>
                  <!-- <p class="mb-0">المديرية العامة للعلاقات والخدمات الاجتماعية</p> -->
                </div>
              </div>
              <button
                type="button"
                id="btn3"
                @click="download"
                class="btn bg-color-blue font-color-white btn-sm mt-2"
              >
                حفظ وصل التسجيل
              </button>
            </div>

            <div class="mt-3">
              <hr />
              <b-button class="" type="button" to="/booths" variant="secondary"
                >رجوع</b-button
              >
            </div>
          </div>

          <!-- loading content -->
          <div v-else-if="loadingContent">
            <vue-content-loading :rtl="true" :width="400" :height="110">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />

              <rect x="10" y="25" rx="1" ry="1" width="50" height="5" />
              <rect x="340" y="25" rx="1" ry="1" width="50" height="5" />

              <rect x="10" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="40" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="49" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="54" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="63" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="68" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="77" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="82" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="91" rx="1" ry="1" width="380" height="1" />
              <circle cx="340" cy="100" r="1" />
              <circle cx="350" cy="100" r="1" />
              <circle cx="363" cy="100" r="4" />
              <circle cx="376" cy="100" r="1" />
              <circle cx="386" cy="100" r="1" />
            </vue-content-loading>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
